import React, { useEffect, useRef } from 'react';

// Injects a Travelpayouts embed widget (tpwidg.com/tp.media) into a container.
// These widgets render their own markup at the location of their <script> tag, so we
// append the script inside a ref'd container and clean it up on unmount. This keeps the
// vendor tag isolated to the page/section that uses it (no global side effects).
//
// SECURITY: `src` is a hard-coded, vendor-controlled Travelpayouts URL supplied by the
// caller — never user input. We build DOM nodes via createElement/appendChild and clear
// via removeChild (NOT innerHTML / dangerouslySetInnerHTML), so no untrusted HTML string
// is ever parsed, avoiding any XSS surface.
export const TravelpayoutsWidget = ({ src, className = '', testid = 'tp-widget', minHeight = 90 }) => {
  const ref = useRef(null);

  useEffect(() => {
    const host = ref.current;
    if (!host) return undefined;
    const clear = () => { while (host.firstChild) host.removeChild(host.firstChild); };
    clear();
    const s = document.createElement('script');
    s.async = true;
    s.charset = 'utf-8';
    s.src = src;
    host.appendChild(s);
    return clear;
  }, [src]);

  return <div ref={ref} className={`w-full max-w-full overflow-x-hidden ${className}`} style={{ minHeight }} data-testid={testid} />;
};

export default TravelpayoutsWidget;
